import SEO from '@Components/SEO/SEO'
import { MenuItem, MenuList } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import clsx from 'clsx'
import { useHistory, useLocation } from 'react-router-dom'
import { $Gray90 } from '../../assets/scss/colors'
import { CommonService } from '../../services/common.service'

const menuItems = [
    {
        name: 'Dashboard',
        link: '/dashboard',
    },
    {
        name: 'Add Firearm',
        link: '/add-firearm',
    },
    {
        name: 'My Vault',
        link: '/my-vault',
    },
    {
        name: 'My Safe Storage',
        link: '/my-safe-storage',
    },
    {
        name: 'Insurance',
        link: '/insurance',
    },
    {
        name: 'Inspection',
        link: '/inspection',
    },

    {
        name: 'Ammunition',
        link: '/ammunition',
    },
    {
        name: 'My Account',
        link: '/my-account',
    },
    {
        name: 'Dispose of Firearm',
        link: '/dispose-of-firearm',
    },
    {
        name: `Firearms Anomaly
        & Resolution`,
        link: '/firearms-anomaly-resolution',
    },
    {
        name: 'Contact',
        link: '/contact',
    },
    {
        name: 'Settings',
        link: '/settings',
    },
]

const useStyles = makeStyles({
    root: {
        paddingTop: 0,
        maxHeight: '67vh',
        overflowX: 'auto',
        '& .MuiButtonBase-root': {
            padding: '12px 30px',
            fontWeight: '600',
            borderBottom: `0.5px solid ${$Gray90}`,
            fontSize: 14,
            whiteSpace: 'normal',
        },
    },
})

function MenuLists() {
    const calsses = useStyles()
    const history = useHistory()
    const location = useLocation()

    // functions section
    const handleRouting = (link: string) => {
        history.push(link)
    }

    // main section
    return (
        <>
            <SEO
                title={`SFP
                    ${CommonService.textCapitalize(
                        location?.pathname?.replaceAll('/', ' - ')
                    )}`}
            />
            <MenuList className={clsx(calsses.root, 'custom-scroll')}>
                {menuItems?.map((menuItem) => (
                    <MenuItem
                        key={`${menuItem?.name}_menu_item`}
                        onClick={() => handleRouting(menuItem.link)}
                        className={`${
                            location?.pathname.includes(menuItem.link)
                                ? 'active-link'
                                : 'inactive-link'
                        }`}
                    >
                        {menuItem?.name}
                        <span className="active-badge" />
                    </MenuItem>
                ))}
            </MenuList>
        </>
    )
}

export default MenuLists
